import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';
import {
  type DiscoveryConfigApiResponse,
  type DiscoveryResponse,
} from '../data-layer/discoveryConfigByIdTypes';

const { GET_DISCOVERY_CONFIG_BY_ID } = getObNextGenApiUrlLists();

export const discoveryConfigByIdApi = createApi({
  reducerPath: 'discoveryConfigByIdApi',
  baseQuery: axiosBaseQuery({ baseUrl: getBaseUrlObNextGen() }),
  tagTypes: ['DiscoveryConfig'],
  endpoints: (builder) => ({
    getDiscoveryConfigById: builder.query<DiscoveryResponse, number>({
      async queryFn(argId, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ({
          url: `${GET_DISCOVERY_CONFIG_BY_ID}${argId}`,
        });

        if (result.error) {
          return { error: result.error };
        }

        const apiResponse = result.data as DiscoveryConfigApiResponse;

        return { data: apiResponse.data };
      },
      providesTags: (_result, _error, argId) => [
        { type: 'DiscoveryConfig' as const, id: argId },
      ],
    }),
  }),
});

export const { useGetDiscoveryConfigByIdQuery } = discoveryConfigByIdApi;
